const highlightSearchResults = () => {
  $(document).ready(function () {
    $('#Search-In-Modal').on('input', function () {
      // console.log('test search1');
      const searchTerm = $(this).val();
      const results = $('#predictive-search-results-list div a');

      results.each(function () {
        const result = $(this);
        const text = result.text();
        const regex = new RegExp(searchTerm, 'gi');

        if (searchTerm.length > 0 && text.match(regex)) {
          const highlightedText = text.replace(
            regex,
            '<span class="highlighted">$&</span>',
          );
          result.html(highlightedText);
        } else {
          result.html(text);
        }
      });
    });
  });
};

export default highlightSearchResults;
